import Grid from "@mui/material/Grid";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useParams } from "react-router-dom";
import { Box, Card, Typography, Button } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import callHistoryDistributorData from "layouts/billing/components/data/callHistoryDistributorData";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import VoicemailIcon from "@mui/icons-material/Voicemail";
import ErrorIcon from "@mui/icons-material/Error";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";

function PageNotFound() {
  return (
    <>
      <header
        style={{
          backgroundColor: "#561919",
          color: "#fff",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <div>
          <Link
            to="https://myheartline.com/"
            style={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              color: "#fff",
              textDecoration: "underline",
            }}
          >
            Heartline
          </Link>
        </div>
      </header>
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    </>
  );
}
function CallHistory() {
  const { token } = useParams();
  console.log(token);
  useEffect(() => {
    if (!token) {
      toast.error("No data found");
    }
  }, [token]);

  if (!token) {
    return <PageNotFound />;
  }

  const [expandedRowIndex, setExpandedRowIndex] = useState(null);

  const handleRowClick = (index) => {
    setExpandedRowIndex(expandedRowIndex === index ? null : index);
  };

  const {
    columns: pColumns,
    rows: pRows,
    isTableDataLoading,
  } = callHistoryDistributorData(expandedRowIndex, handleRowClick, token);
  const isMobile = useMediaQuery("(max-width:650px)");

  const [page, setPage] = useState(0);
  const [showSummary, setShowSummary] = useState(true);

  const statusLabels = {
    0: "No Answer / Voicemail",
    1: "Incomplete",
    2: "Complete",
    3: "Connection Error",
  };

  const renderScoreEmoji = (score) => {
    if (!score || isNaN(score) || score < 1 || score > 5) return null;

    const labelMap = {
      1: "Very Poor",
      2: "Poor",
      3: "Fair",
      4: "Good",
      5: "Very Good",
    };

    const svgPath = `/svgs/${score}.svg`; // Adjust folder if needed
    const label = labelMap[score];

    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box component="img" src={svgPath} alt={`Score ${score}`} sx={{ width: 24, height: 24 }} />
        <span>{label}</span>
      </Box>
    );
  };

  const injectScoreIconsReorderInline = (html, { svgBase = "/svgs" } = {}) => {
    if (!html || typeof window === "undefined") return html;

    const labelMap = { 1: "Very Poor", 2: "Poor", 3: "Fair", 4: "Good", 5: "Very Good" };
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("span[data-hl-score]").forEach((marker) => {
      const li = marker.closest("li") || marker.parentElement;
      if (!li) return;

      const score = Number(marker.getAttribute("data-hl-score"));
      if (!(score >= 1 && score <= 5)) {
        marker.remove();
        return;
      }

      const label = labelMap[score] || "";
      const svg = `${svgBase}/${score}.svg`;

      // Remove trailing ":" from "<strong>Topic:</strong>"
      const strong = li.querySelector("strong");
      if (strong && strong.textContent) {
        strong.textContent = strong.textContent.replace(/:\s*$/, "");
      }

      // Pure inline chunk:  — [icon + label] :
      // Pure inline chunk: — [icon + STRONG label] :
      const chunk =
        `<br> <span class="hl-status" style="display:inline-flex;align-items:center;gap:6px;">` +
        `<img src="${svg}" alt="Score ${score}" width="20" height="20" style="vertical-align:middle;display:inline-block">` +
        `<strong style="font-weight:600">${label}</strong></span><br>`;

      if (strong) {
        strong.insertAdjacentHTML("afterend", chunk);
      } else {
        li.insertAdjacentHTML("afterbegin", chunk);
      }
      li.insertAdjacentHTML("afterend", "<br>");
      marker.remove();
    });

    return doc.body.innerHTML;
  };
  const renderSentimentEmoji = (sentiment) => {
    const labelMap = {
      1: "Negative",
      2: "Neutral",
      3: "Positive",
    };

    const svgMap = {
      1: "1",
      2: "3",
      3: "5",
    };

    if (![1, 2, 3].includes(sentiment)) return null;

    const label = labelMap[sentiment];
    const svgScore = svgMap[sentiment];
    const svgPath = `/svgs/${svgScore}.svg`;

    return (
      <Tooltip title={label}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box component="img" src={svgPath} alt={label} sx={{ width: 24, height: 24 }} />
        </Box>
      </Tooltip>
    );
  };

  const renderStatusIcon = (status) => {
    let icon = null;
    let color = "";
    let label = "";

    switch (status) {
      case 0:
        icon = <VoicemailIcon sx={{ fontSize: 24, color: "#90caf9" }} />;
        label = "No Answer / Voicemail";
        break;
      case 1:
        icon = <CheckCircleOutlineIcon sx={{ fontSize: 24, color: "#ff9800" }} />;
        label = "Partial Complete";
        break;
      case 2:
        icon = <CheckCircleIcon sx={{ fontSize: 24, color: "#4caf50" }} />;
        label = "Complete";
        break;
      case 3:
      default:
        icon = <ErrorIcon sx={{ fontSize: 24, color: "#f44336" }} />;
        label = "Connection Error";
    }

    return (
      <Tooltip title={label}>
        <Box
          sx={{
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {icon}
        </Box>
      </Tooltip>
    );
  };

  return (
    <>
      <header
        style={{
          backgroundColor: "#561919",
          color: "#fff",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <div>
          <Link
            to="https://myheartline.com/"
            style={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              color: "#fff",
              textDecoration: "underline",
            }}
          >
            Heartline
          </Link>
        </div>

        {/* <nav style={{ display: "flex", gap: "2rem" }}>
          <Link
            to="https://myheartline.com/contact/"
            style={{
              textDecoration: "none",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Contact
          </Link>
          <Link
            to="/authentication/demo"
            style={{
              textDecoration: "none",
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            Demo
          </Link>
        </nav> */}
      </header>
      <MDBox mx={2} mt={-3} py={3} px={2}>
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  bgColor="rgb(86,25,25)"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDBox bgColor="rgb(86,25,25)" borderRadius="lg" display="flex">
                    <PhoneIcon fontSize="medium" color="white" />
                    <MDTypography variant="h6" color="white" px={1}>
                      Call History
                    </MDTypography>
                  </MDBox>

                  <DashboardNavbar />
                </MDBox>
                <MDBox pt={3}>
                  {!isMobile ? (
                    <DataTable
                      table={{ columns: pColumns, rows: pRows }}
                      isSorted={true}
                      //  canSearch={true}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                      isTableDataLoading={isTableDataLoading}
                    />
                  ) : (
                    <>
                      {pRows.length > 0 && (
                        <Box>
                          <Box sx={{ mb: 0, p: 2, borderRadius: 0 }}>
                            <Box mb={1}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                Date
                              </Typography>
                              <Typography variant="body2">{pRows[page].date}</Typography>
                            </Box>
                            <Box mb={1}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                Time
                              </Typography>
                              <Typography variant="body2">{pRows[page].time}</Typography>
                            </Box>
                            <Box mb={1}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                Status
                              </Typography>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="flex-start"
                                height="100%"
                              >
                                {renderStatusIcon(pRows[page].status)}
                              </Box>
                            </Box>
                            <Box mb={1}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                Sentiment
                              </Typography>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="flex-start"
                                height="100%"
                              >
                                {renderSentimentEmoji(pRows[page].sentiment)}
                              </Box>
                            </Box>
                            <Box mb={1}>
                              <Typography variant="subtitle2" fontWeight="bold">
                                Summary
                              </Typography>
                              <Typography
                                variant="body2"
                                component="div"
                                dangerouslySetInnerHTML={{
                                  __html: injectScoreIconsReorderInline(
                                    pRows?.[page]?.callSummary || ""
                                  ),
                                }}
                              />
                            </Box>
                            {/* {Object.entries(pRows[page]?.topicSummaries || {}).map(
                              ([key, value]) => (
                                <Box mb={1} key={key}>
                                  <Typography variant="subtitle2" fontWeight="bold">
                                    {key}
                                  </Typography>
                                  <Typography variant="body2">
                                    {renderScoreEmoji(value) || "—"}
                                  </Typography>
                                </Box>
                              )
                            )} */}
                          </Box>
                        </Box>
                      )}

                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap={2}
                        mt={2}
                        mb={3}
                        flexWrap="wrap" // ensures wrap if space gets tight
                        textAlign="center"
                      >
                        <Button
                          size="small"
                          sx={{
                            backgroundColor: "rgb(86,25,25)",
                            color: "#ffffff !important",
                            px: 4,
                            "&:hover": {
                              backgroundColor: "#6A1B1B",
                              color: "#ffffff",
                            },
                            "&:focus": {
                              backgroundColor: "rgb(86,25,25)",
                              color: "#ffffff !important",
                              outline: "none",
                              boxShadow: "none",
                            },
                            maxWidth: 90,
                            fontSize: "0.7rem",
                          }}
                          variant="outlined"
                          disabled={page === 0}
                          onClick={() => setPage(page - 1)}
                        >
                          Previous
                        </Button>

                        <Typography
                          variant="caption"
                          sx={{
                            minWidth: 60,
                            fontWeight: 500,
                            fontSize: "0.7rem",
                          }}
                        >
                          Page {page + 1} of {pRows.length}
                        </Typography>

                        <Button
                          size="small"
                          sx={{
                            backgroundColor: "rgb(86,25,25)",
                            color: "#ffffff !important",
                            px: 4,
                            "&:hover": {
                              backgroundColor: "#6A1B1B",
                              color: "#ffffff",
                            },
                            "&:focus": {
                              backgroundColor: "rgb(86,25,25)",
                              color: "#ffffff !important",
                              outline: "none",
                              boxShadow: "none",
                            },
                            maxWidth: 70,
                            fontSize: "0.7rem",
                          }}
                          variant="outlined"
                          disabled={page + 1 >= pRows.length}
                          onClick={() => setPage(page + 1)}
                        >
                          Next
                        </Button>
                      </Box>
                    </>
                  )}
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </>
  );
}
export default CallHistory;
